import Vue from 'vue';
import VueRouter from 'vue-router';
import { Auth } from 'aws-amplify';
import store from '../store';

import Products from '../views/Products.vue';
import Layout from '../views/Layout.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Layout',
    component: Layout,
    children: [
      {
        path: '/products',
        name: 'Products',
        component: Products,
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: '/add',
        name: 'Add',
        component: () => import(/* webpackChunkName: "Add" */ '../views/Add.vue'),
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: '/products/:id',
        name: 'ProductDetail',
        component: () =>
          import(/* webpackChunkName: "ProductDetail" */ '../views/ProductDetail.vue'),
        meta: { requiresAuth: true, requiresAdmin: true },
      },
      {
        path: '/',
        name: 'Drops',
        component: () => import(/* webpackChunkName: "Drops" */ '../views/Drops.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: '/drops/:id',
        name: 'DropDetail',
        component: () => import(/* webpackChunkName: "DropDetail" */ '../views/DropDetail.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: '/areas',
        name: 'Areas',
        component: () => import(/* webpackChunkName: "Areas" */ '../views/Areas.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: '/areas/:areaId',
        name: 'Areas',
        component: () => import(/* webpackChunkName: "AreaDetail" */ '../views/AreaDetail.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: '/admin',
        name: 'Admin',
        component: () => import(/* webpackChunkName: "Admin" */ '../views/Admin.vue'),
        meta: { requiresAuth: true, requiresAdmin: true },
      },
    ],
  },
  {
    path: '/auth',
    component: () => import(/* webpackChunkName: "AuthComponent" */ '../views/AuthComponent.vue'),
  },
  {
    path: '*',
    redirect: '/',
  },
];

const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    return savedPosition;
  }
  return { x: 0, y: 0 };
};

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior,
});

router.beforeResolve((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    Auth.currentAuthenticatedUser()
      .then((user) => {
        if (user) {
          store.commit('setCurrentUser', user);
          if (to.matched.some((record) => record.meta.requiresAdmin)) {
            if (store.getters.isAdmin) {
              next();
            } else {
              next({ path: '/' });
            }
          } else {
            next();
          }
        }
      })
      .catch(() => {
        next({
          path: '/auth',
        });
      });
  }
  next();
});

export default router;
